module.exports = __webpack_public_path__ + "img/tu.c4c2cff8.png";